import BenefitsScreen from "./BenefitsScreen";
export default BenefitsScreen;